import "./class-component-hooks"; // needs to be imported before any components
import Vue from "vue";
// Lokal gebundelte Schrift/Icons statt CDN (DSGVO): ersetzt die frueheren
// <link>-Tags auf fonts.googleapis.com und cdn.jsdelivr.net in index.html.
import "@mdi/font/css/materialdesignicons.css";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "./assets/main.css";
// @ts-ignore
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import Moment from "moment";
import axios from "axios";
import "./log.js";
import FloatingVue, { VTooltip } from "floating-vue";
import "floating-vue/dist/style.css";

Vue.filter("formatDate", (value: any) => {
	if (value) {
		return Moment(String(value)).format("DD.MM.YYYY");
	}
});

Vue.filter("formatDateTime", (value: any) => {
	if (value) {
		return Moment(String(value)).format("DD.MM.YYYY HH:mm");
	}
});

Vue.filter("formatTimespan", (value: any) => {
	if (value) {
		return Moment(String(value)).format("hh:mm:ss");
	}
});

Vue.filter("round2Decimal", (value: number) => {
	if (value !== undefined && value !== null) {
		value = Math.round(value * 100) / 100;
		return value.toFixed(2);
	}
});

Vue.filter("round3Decimal", (value: number) => {
	if (value !== undefined && value !== null) {
		value = Math.round(value * 1000) / 1000;
		return value.toFixed(3);
	}
});

Vue.filter("format2Digits", (value: number) => {
	if (value !== undefined && value !== null) {
		return value.toLocaleString(undefined, { minimumIntegerDigits: 2 });
	}
});

Vue.filter("format2Decimal", (value: number) => {
	if (value !== undefined && value !== null) {
		return value.toFixed(2);
	}
});

Vue.config.productionTip = false;
console.log("running: " + process.env.VUE_APP_MODE);

// Floating Vue used for hint tooltips
// https://floating-vue.starpad.dev/
Vue.use(FloatingVue);

// Checking if this request is a logout request
// eg. if the user changes their email address they are
// routed to a shop-logout.
// If they are not logged in, they must be routed to the login mask.
const urlHash = window.location.hash;
let isLogoutRedirect = false;
if (urlHash === "#/Logout" || urlHash === "#/Logout/") {
	isLogoutRedirect = true;
}

// Prüft die geladene Client-Version gegen die Backend-Version. Läuft VOR dem
// Bootstrap (auch vor dem Login) als zusätzliche Absicherung: Hat ein Kunde eine
// veraltete, gecachte Version geladen, wird das hier erkannt und ein frischer
// Reload erzwungen - unabhängig vom Browser-Cache. Siehe VersionController im Server.
async function checkClientVersion(): Promise<void> {
	const reloadFlag = "blexon_version_reload";
	try {
		const clientPackage = JSON.parse(unescape(process.env.PACKAGE_JSON || "%7B%7D"));
		const clientVersion = (clientPackage.version || "").toString().trim();
		if (!clientVersion) {
			return;
		}
		const response = await axios.get(`${process.env.VUE_APP_SERVER_URL}Version`, {
			headers: { "Cache-Control": "no-cache" },
		});
		const backendVersion = (response.data || "").toString().trim();
		// Kein sinnvoller Wert vom Backend (z.B. nicht gesetzter Platzhalter) -> nichts tun.
		if (!backendVersion || backendVersion === "0.0.0") {
			return;
		}
		if (backendVersion === clientVersion) {
			window.sessionStorage.removeItem(reloadFlag);
			return;
		}
		// Version weicht ab. Endlosschleife vermeiden: pro Backend-Version nur einmal neu
		// laden. Bleibt es danach veraltet (z.B. hartnäckiger Proxy-Cache), nicht erneut.
		if (window.sessionStorage.getItem(reloadFlag) === backendVersion) {
			console.warn(
				`Version weiterhin veraltet (Client ${clientVersion}, Backend ${backendVersion}) - kein weiterer Reload.`
			);
			return;
		}
		window.sessionStorage.setItem(reloadFlag, backendVersion);
		console.log(
			`Neue Version verfügbar (Client ${clientVersion} -> Backend ${backendVersion}), lade neu.`
		);
		// Cache umgehen: URL mit Versions-Query erzwingt ein frisches Laden der index.html.
		const url = new URL(window.location.href);
		url.searchParams.set("v", backendVersion);
		window.location.replace(url.toString());
		// Promise, die nie auflöst, damit der Bootstrap nicht startet, während neu geladen wird.
		await new Promise<void>(() => {});
	} catch (e) {
		// Best-effort: Bei Fehlern (Backend nicht erreichbar o.ä.) normal weiterstarten.
		console.warn("Version-Check fehlgeschlagen:", e);
	}
}

// Erst Version prüfen, dann die App initialisieren.
checkClientVersion().then(() => {
	// Setup main page
	store
		.dispatch("bootstrap")
		.then(async () => {
			console.log("Successfully bootstrapt application");
			if (isLogoutRedirect) {
				store.dispatch("logout");
			} else {
				store
					.dispatch("checkAccess")
					.then(async () => {
						store.dispatch("setupSignalR").then(() => {
							const app = new Vue({
								router,
								store,
								vuetify,
								i18n,
								render: (h) => h(App),
							}).$mount("#app");
						});
					})
					.catch((e) => {
						console.log("Keine Berechtigung");
						store.dispatch("logout");
					});
			}
		})
		.catch((e) => console.log(e));
});
